export const TIME_INTERVAL_ORDER = 20000;
export const TIME_INTERVAL_ELECTRON_LOAD = 8000;

export const SDK_NGX_NIX = "NGX_NIX_SDK_1_0_1";
export const SDK_NGX_ASHWA = "NGX_ASHWA_SDK_1_0_5_1";
export const SDK_SUNMI_PRO2 = "SDK_SUNMI_PRO2";
export const SDK_SUNMI_MINI_T1 = "SDK_SUNMI_MINI_T1";
export const SDK_CHROME = "CHROME";
export const SDK_CHROME_ELECTRON = "CHROME_ELECTRON";
// Order place store
export const REGION_KEY_LOCAL = "gng-web-lite-region-id";
export const CHECKOUT_LOCAL_KEY = "gng-web-lite-previousC-checkout";
export const CHECKOUT_ITEM_COUNT = "gng-web-lite-items-in-cart";

// Hub QRCODE
export const HUB_QRCODE = "GNG-HUB-";
// santosh added pending dispatched
export const ORDER_STATUS = {
  new: "New",
  pushed: "Pushed",
  accepted: "Accepted",
  ready: "Ready",
  pendingdispatched: "PENDINGDISPATCHED",
  dispatched: "Dispatched",
  delivered: "Delivered",
  rejected: "Rejected",
};
export const OREDER_MODES = {
  // dineIn: "DINEIN",
  takeAway: "TAKEAWAY",
  delivery: "DELIVERY",
};



// WEBPACK FOOTER //
// ./src/config/Constants.js